import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import TaskSkeleton from "./TaskSkeleton";

export default function FeesTypeHeadList2() {
    const { http, user } = AuthUser();
    const [heads, setHeads] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [name, setName] = useState("");
    const [editId, setEditId] = useState(null);
    const [editName, setEditName] = useState("");

    useEffect(() => {
        fetchHeads();
    }, []);

    const fetchHeads = async () => {
        setIsLoading(true);
        try {
            const res = await http.get(`/fees_type_heads_2?login_user=${user.id}`);
            if (res.data.success) setHeads(res.data.data || []);
        } catch (err) {
            console.error("Error fetching fees type heads 2:", err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleAdd = async (e) => {
        e.preventDefault();
        if (!name.trim()) { toast.error("Please enter a name"); return; }
        try {
            const res = await http.post(`/fees_type_head_2?login_user=${user.id}`, { name: name.trim() });
            if (res.data.success) {
                toast.success("Fees Type Head 2 added!");
                setName("");
                fetchHeads();
            }
        } catch (err) {
            toast.error("Error adding");
        }
    };

    const handleUpdate = async (id) => {
        if (!editName.trim()) { toast.error("Name cannot be empty"); return; }
        try {
            const res = await http.put(`/fees_type_head_2/${id}`, { name: editName.trim() });
            if (res.data.success) {
                toast.success("Updated!");
                setEditId(null);
                setEditName("");
                fetchHeads();
            }
        } catch (err) {
            toast.error("Error updating");
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this?")) return;
        try {
            const res = await http.delete(`/fees_type_head_2/${id}`);
            if (res.data.success) {
                toast.success("Deleted!");
                fetchHeads();
            }
        } catch (err) {
            toast.error("Error deleting");
        }
    };

    return (
        <>
            <Toaster />
            <div className="container mt-3">
                <h5 className="fw-bold mb-3">Fees Type Head - 2 List</h5>

                <form onSubmit={handleAdd} className="row g-2 align-items-center mb-3">
                    <div className="col-md-5">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            placeholder="Enter Fees Type Head 2 Name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="col-auto">
                        <button type="submit" className="btn btn-sm btn-success px-3">
                            <i className="fas fa-plus me-1"></i>Add
                        </button>
                    </div>
                </form>

                {isLoading ? (
                    <TaskSkeleton />
                ) : (
                    <table className="table table-striped table-sm">
                        <thead className="table-primary">
                            <tr>
                                <th style={{width: '50px'}}>No</th>
                                <th>Name</th>
                                <th style={{width: '180px'}}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {heads.length === 0 ? (
                                <tr><td colSpan={3} className="text-center text-muted py-3">No records found. Add one above.</td></tr>
                            ) : (
                                heads.map((head, idx) => (
                                    <tr key={head.id}>
                                        <td>{idx + 1}</td>
                                        <td>
                                            {editId === head.id ? (
                                                <input type="text" className="form-control form-control-sm" value={editName} onChange={(e) => setEditName(e.target.value)} autoFocus />
                                            ) : (
                                                head.name
                                            )}
                                        </td>
                                        <td>
                                            {editId === head.id ? (
                                                <div className="d-flex gap-1">
                                                    <button className="btn btn-sm btn-primary px-2" onClick={() => handleUpdate(head.id)}><i className="fas fa-check"></i></button>
                                                    <button className="btn btn-sm btn-secondary px-2" onClick={() => { setEditId(null); setEditName(""); }}><i className="fas fa-times"></i></button>
                                                </div>
                                            ) : (
                                                <div className="d-flex gap-1">
                                                    <button className="btn btn-sm btn-outline-primary px-2" onClick={() => { setEditId(head.id); setEditName(head.name); }}><i className="fas fa-edit"></i></button>
                                                    <button className="btn btn-sm btn-outline-danger px-2" onClick={() => handleDelete(head.id)}><i className="fas fa-trash"></i></button>
                                                </div>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                )}
            </div>
        </>
    );
}
